import { Login } from "@/api/user";

import { getToken, setToken, removeToken } from "@/utils/auth";

const user = {
  state: {
    user: "",
    status: "",
    token: getToken(),
    name: "",
    avatar: "",
    introduction: "",
    items: [],
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ITEMS: (state, items) => {
      state.items = items;
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    SET_USERINFO: (state, items) => {
      
    }
  },

  actions: {
    // 用户名登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        Login(userInfo)
          .then((response) => {
            const data = response.data;
            if (data.status === 200) {
              localStorage.setItem("userName", data.data.items[0].userName);
              setToken(data.data.items[0].token);
              commit('SET_TOKEN', data.data.items[0].token);
            }
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default user;
